import TeaserSmall from '@/elements/widgets/Teaser/Small/TeaserSmall'
import { WidgetTeaserProps } from '@/types/cms'
import AppContext from '@/types/context'

const TeaserSmallInline = ({ item, context }: { item: WidgetTeaserProps; context: AppContext }) => {
  return <TeaserSmall item={item} context={context} inline />
}

export default TeaserSmallInline
